<template>
  <button
    ref="menuTarget"
    aria-label="menu"
    aria-haspopup="true"
    aria-controls="mobile-nav"
    :aria-expanded="isMenuOpened"
    class="menu-icon"
    data-testid="burger-button"
    data-block-outside-click
    @click="toggleNav"
  ></button>
</template>

<script setup>
import { useMobileNav } from '~/composables/useMobileNav';

const { menuTarget, isMenuOpened, toggleNav } = useMobileNav();
</script>

<style lang="scss" brand="mcom">
@import '~/assets/scss/icons.mcom.scss';

.menu-icon {
  @extend .menu-dark-medium;
}
</style>

<style lang="scss" brand="bcom">
@import '~/assets/scss/icons.bcom.scss';

.menu-icon {
  @extend .menu-small;
}
</style>
